module.exports = __webpack_public_path__ + "static/media/facebook.01ecb4a7.svg";